import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Turbo Drive for fast page transitions
import * as Turbo from "@hotwired/turbo"

// Set progress bar delay (shows after 100ms for slower loads)
Turbo.config.drive.progressBarDelay = 100

// Ministry of Truth puzzle — fallback for the in-page popstate trap. If the
// user left ministry via back/forward (and pushState was skipped because they
// hadn't interacted), reroute them to /game/history-rewritten/. Forward
// navigation (link, address bar, console) just clears the flag.
function checkMinistryRedirect(event) {
  if (sessionStorage.getItem("onMinistryPage") !== "true") return
  const path = window.location.pathname.replace(/\/$/, "")
  if (path === "/game/ministry-of-truth" || path === "/game/history-rewritten") return

  const navType = performance.getEntriesByType("navigation")[0]?.type
  const isBackForward = event?.persisted === true || navType === "back_forward"
  sessionStorage.removeItem("onMinistryPage")
  if (isBackForward) {
    window.location.replace("/game/history-rewritten/")
  }
}
document.addEventListener("turbo:load", checkMinistryRedirect)
window.addEventListener("pageshow", checkMinistryRedirect)

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Stimulus controllers for the game
import { Application } from "@hotwired/stimulus"
import EPController from "./controllers/game/e_p_controller"
import HIPSController from "./controllers/game/h_i_p_s_controller"
import LTBLController from "./controllers/game/l_t_b_l_controller"
import MOTController from "./controllers/game/m_o_t_controller"
import MYMController from "./controllers/game/m_y_m_controller"
import RDController from "./controllers/game/r_d_controller"
import ClsController from "./controllers/cls_controller"

const application = Application.start()
application.register("e-p", EPController)
application.register("h-i-p-s", HIPSController)
application.register("l-t-b-l", LTBLController)
application.register("m-o-t", MOTController)
application.register("m-y-m", MYMController)
application.register("r-d", RDController)
application.register("cls", ClsController)
